import { Avatar, Flex, Space, Tag, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const { Text } = Typography;

export const StepCollapseLabel = ({ step, icon, title, primaryColor, isActive, isCompleted }) => {
  return (
    <Flex justify='space-between' align='center'>
      <Space size='middle'>
        {isActive && <Avatar icon={<FontAwesomeIcon icon={icon} fontSize={16} />} style={{ backgroundColor: '#ffffff', color: primaryColor }} />}
        {isCompleted && <Avatar icon={<FontAwesomeIcon icon={faCheck} fontSize={16} />} style={{ backgroundColor: primaryColor }} />}
        <Text strong style={{ fontSize: '1.1em', color: 'inherit' }}>{step + 1}. {title}</Text>
      </Space>
      <Tag color={isCompleted ? 'success' : 'default'} style={{ margin: 0, width: '7em', textAlign: 'center', 'borderRadius': '1em' }}>
        <Text strong style={{ color: isCompleted ? 'inherit' : primaryColor, fontSize: 'inherit' }} >
          {isCompleted ? 'Completado' : 'En proceso'}
        </Text>
      </Tag>
    </Flex>
  );
};